(function() {
	'use strict';

	angular.module('quantixApp').factory('renewableEnergyService',
			renewableEnergyService);

	renewableEnergyService.$inject = [ '$resource', '$http', '$q', '$window' ];

	function renewableEnergyService($resource, $http, $q, $window) {
		
		var _getProjectAllocationList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getProjectAllocationListInfra';

			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		//getPpaCounterparty
		var _getProjectStatusList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getProjectStatusListInfra';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getPpaCounterpartyList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getPpaCounterparty';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getFuelMasterList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getFuelMasterListInfra';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getIssuerList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getIssuerNameListInfra';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getStateNameList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getStateName';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getUniquePsaCounterParty = function() {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getPsaCounterparty';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getMinMaxSchemeCapacity = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getMinMaxSchemeCapacity';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getMinMaxBidTariff = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getMinMaxBidTariff';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getCapacityAllocatedMw = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getCapacityAllocatedMw';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getDistinctCommercialOpDate = function() {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getDistinctCommercialOpDate';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getDistinctMonthOfAllocation = function() {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getDistinctMonthOfAllocation';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getDistinctMonthOfReleaseTender = function() {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getDistinctMonthOfReleaseTender';
			$http.get(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getSectorList = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getSectorList';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getProjectDataMapForSelection = function(selectedFilterJson) {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/getRenewableEnergyForSelection';
			$http.post(url, JSON.parse(selectedFilterJson)).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _viewRenewabledata = function(selectedFilterJson) {
			var deferred = $q.defer();
			var url = 'api/infrastructureProjects/viewRenewabledata';
			$http.post(url, JSON.parse(selectedFilterJson)).then(function(response) {
				deferred.resolve(response);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		return {
			getProjectAllocationList : _getProjectAllocationList,
			getProjectStatus : _getProjectStatusList,
			getFuelMaster : _getFuelMasterList,
			getSectorList : _getSectorList,
			getIssuerList : _getIssuerList,
			getMinMaxSchemeCapacity : _getMinMaxSchemeCapacity,
			getMinMaxBidTariff : _getMinMaxBidTariff,
			getCapacityAllocatedMw : _getCapacityAllocatedMw,
			getPpaCounterpartyList : _getPpaCounterpartyList,
			getDistinctCommercialOpDate : _getDistinctCommercialOpDate,
			getDistinctMonthOfAllocation : _getDistinctMonthOfAllocation,
			getDistinctMonthOfReleaseTender : _getDistinctMonthOfReleaseTender,
			getProjectDataMapForSelection : _getProjectDataMapForSelection,
			viewRenewabledata : _viewRenewabledata,
			getStateNameList : _getStateNameList,		
			getUniquePsaCounterParty: _getUniquePsaCounterParty
		}
	}
})();
